import type { ElectronContext } from '@mimir/common/context/applicationContext';
import { ConsoleLogger } from '@mimir/common/util/logging';
import { premiere } from '../globals/premiere';
import { startCheckOpenProjectsLoop } from '../premiere/checkOpenProjects';
import { getGlobalStore } from '../store';
import type { BasicUploadManager } from '@mimir/common/upload/BasicUploadManager';
import type { QuickPreview } from '../model/quickPreview';

export function enableDvrWorkflowIntegration(
  applicationContext: ElectronContext,
  uploadManager: BasicUploadManager,
  quickPreview: QuickPreview,
) {
  getGlobalStore().commit('setDvrWorkflowIntegrationLaunched', true);
  void getGlobalStore().dispatch('setDvrMode', { applicationContext: applicationContext, val: true });
  const logger = new ConsoleLogger();

  // startCheckOpenProjectsLoop should take care to not start concurrent looping even if this is
  // called multiple times e.g. for starting the plugin from DVR when it is already running.
  startCheckOpenProjectsLoop(applicationContext, logger, premiere.clipInfos, getGlobalStore().getters.ongoingUploads, uploadManager, quickPreview).catch(err => console.error(err));
};

export const disableDvrWorkflowIntegration = (
  applicationContext: ElectronContext,
) => {
  void applicationContext.mainRequire('./dvr').cleanup();
  getGlobalStore().commit('setDvrWorkflowIntegrationLaunched', false);
  void getGlobalStore().dispatch('setDvrMode', { applicationContext: applicationContext, val: false });
};
